module.exports = "<h1>Configuração de perfil</h1>\n<mandae-profile-setting-form></mandae-profile-setting-form>\n"